var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"border-bottom-light"},[_c('div',{staticClass:"signature-box p-16"},[_c('img',{staticClass:"signature-image",attrs:{"src":_vm.signature.image,"width":"100%"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }